// 协议相关方法
import {crc16modbus} from "crc"


/**
 * 计算crc校验码
 * @param str 需要计算的字符串
 * @return {string} 计算后得出的 crc
 */
export function getCrc(str) {
  let typedArray = new Uint8Array(str.match(/[\da-f]{2}/gi).map(function (h) {
    return parseInt(h, 16)
  }))
  let crc = crc16modbus(typedArray.buffer).toString(16);
  return crc_desc(crc);
}

/**
 * 将字符串转换为大写并移除空格
 * @param {string} a - 需要转换的字符串
 * @returns {string} 转换后的字符串
 */
function crc_desc(a) {
  const result = a.toUpperCase().replace(/ /g, '');

  // 交换位置并填充零
  const arr = result.split('');
  const swappedArr = [
    arr[2], arr[3],
    arr[0], arr[1],
    arr[4], arr[5],
    arr[6], arr[7]
  ];

  return swappedArr.join('');
}


/**
 * 获取协议
 * @param prefix 协议前缀 如：ee 05 02 00
 * @param decimal 需要转化的十进制数
 * @param byteLength 需要转化的字节长度
 * @return {string, null} 协议
 */
export function getProtocol(prefix, decimal, byteLength = 1) {
  if(!decimal) return null;

  // 判断 decimal 是否是 number
  if (typeof decimal !== 'number') {
    throw new Error('decimal 必须为 number 类型')
  }
  const str = prefix + decimalToHex(decimal, byteLength)
  const crc = getCrc(str);
  return str + crc + 'ef';
}


/**
 * 十进制转十六进制
 * @param decimal 十进制
 * @param byteLength 转换后返回需要的字节长度
 * @return {string} 十六进制
 */
export function decimalToHex(decimal, byteLength = 1) {
  // 判断 decimal 如果是字符串并值是number方可
  if (typeof decimal === 'string' && !isNaN(Number(decimal))) {
    decimal = Number(decimal)
  }

  // 判断是否是 number
  if (typeof decimal !== 'number') {
    throw new Error('Input must be a number');
  }
  // 十进制转十六进制
  let hex = decimal.toString(16);
  // 如果转换后的十六进制长度小于2，则在前面补0
  if (hex.length % 2 !== 0) hex = '0' + hex;

  // 判断当前转换的hex长度是否满足，不满足后面补0
  while (hex.length < byteLength * 2) {
    hex += '00';
  }
  return hex;
}




